import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router } from '@angular/router';
import { Restaurant } from '../classes/restaurant';
import { LocationService } from './location.service';
import { DB, RESPONSE, RESULT } from './env.service';

@Injectable({
	providedIn: 'root'
})
export class DomicilioResolver implements Resolve<Restaurant> {
  
  public restaurant: Restaurant = {};

  constructor(
    private router: Router,
    public locService: LocationService
  ) {}

  // Resolver
  async resolve(route: ActivatedRouteSnapshot): Promise<any> {

    //this.restaurantService.loadList(route.queryParams.id_menu);
    this.locService.deliveryNext(null);
    //await new Promise(resolve => setTimeout(resolve, 1000));    
    this.locService.loadDelivery_Rslug(route.params.slug, true).subscribe(data => {
      if (
        data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
        data[RESPONSE.JP_RESULT]
      ) {
        this.locService.deliveryNext(data[RESPONSE.JP_RESULT]);
      }else{
        this.router.navigateByUrl('/pages/404', {skipLocationChange: true});
      }
    }, (err) => {
      console.log(err);
      //this.loadingService.hide();
      this.router.navigateByUrl('/pages/404', {skipLocationChange: true});
    })
    return this.restaurant;
  }

  /*
  // Resolver
  async resolvetables(route: ActivatedRouteSnapshot): Promise<any> {

    //this.restaurantService.loadList(route.queryParams.id_menu);
    await new Promise(resolve => setTimeout(resolve, 1000));    
    this.restaurantService.getRestaurantBySlug(route.params.slug_booking, true).subscribe(data => {
      if (
        data[RESPONSE.JP_STATUS] == RESPONSE.JPS_OK &&
        data[RESPONSE.JP_RESULT]
      ) {
        this.restaurant = data[RESPONSE.JP_RESULT];
        this.restaurantService.nextRestaurant(this.restaurant);
      }else{
        this.router.navigateByUrl('/pages/404', {skipLocationChange: true});
      }
    }, (err) => {
      console.log(err);
      //this.loadingService.hide();
      this.router.navigateByUrl('/pages/404', {skipLocationChange: true});
    })
    return this.restaurant;
  }
  */
  
}
